function getProductAvailabilityContainer(form) {
  const productRerender = form?.closest('product-rerender');

  if (productRerender) {
    return productRerender.querySelector('[data-product-availability]');
  }

  return document.querySelector('[data-product-availability]');
}

function getQuantity(form) {
  if (!form) return 1;

  const quantityInput =
    document.querySelector(`input[name="quantity"][form="${form.id}"]`) ||
    form.querySelector('input[name="quantity"]');

  const quantity = parseInt(quantityInput?.value || '1', 10);

  return Number.isNaN(quantity) ? 1 : quantity;
}

function renderProductAvailability(container, variantId, requestedQuantity = 1) {
  if (!container || !variantId) return;

  const inventoryDataElement = container.querySelector('[data-variant-inventory]');
  const messageContainer = container.querySelector('[data-availability-message]');

  if (!inventoryDataElement || !messageContainer) return;

  let inventory = {};

  try {
    inventory = JSON.parse(inventoryDataElement.textContent);
  } catch (error) {
    return;
  }

  const inventoryQty = Number(inventory[String(variantId)] || 0);
  const leadTime = container.dataset.leadTime || '';

  container.dataset.currentVariantId = variantId;

  if (inventoryQty > 0 && requestedQuantity <= inventoryQty) {
    const itemLabel = inventoryQty === 1 ? 'item' : 'items';

    messageContainer.innerHTML = `
      <div class="product-info__lead-time product-info__lead-time--stock">
        <p>
          <span>
            <strong>${inventoryQty} ${itemLabel}</strong>
            in stock
          </span>
        </p>
      </div>
    `;

    return;
  }

  if (inventoryQty > 0 && requestedQuantity > inventoryQty) {
    const stockLabel = inventoryQty === 1 ? 'item' : 'items';
    const remainingQty = requestedQuantity - inventoryQty;
    const remainingLabel = remainingQty === 1 ? 'item' : 'items';

    let html = `
      <div class="product-info__lead-time product-info__lead-time--stock">
        <p>
          <span>
            <strong>${inventoryQty} ${stockLabel}</strong>
            in stock
          </span>
        </p>
      </div>
    `;

    if (leadTime) {
      html += `
        <div class="product-info__lead-time product-info__lead-time--lead">
          <p>
            <svg
              class="product-info__lead-time-icon"
              aria-hidden="true"
              viewBox="0 0 24 24"
              fill="none"
            >
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                stroke-width="1.7"
              ></circle>
              <path
                d="M12 7v5l3 2"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>

            <span>
              Remaining <strong>${remainingQty} ${remainingLabel}</strong>:
              approximately <strong>${leadTime}</strong>
            </span>
          </p>
        </div>
      `;
    }

    messageContainer.innerHTML = html;
    return;
  }

  if (leadTime) {
    messageContainer.innerHTML = `
      <div class="product-info__lead-time product-info__lead-time--lead">
        <p>
          <svg
            class="product-info__lead-time-icon"
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle
              cx="12"
              cy="12"
              r="9"
              stroke="currentColor"
              stroke-width="1.7"
            ></circle>
            <path
              d="M12 7v5l3 2"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>

          <span>
            Buy now and receive it in approximately
            <strong>${leadTime}</strong>
          </span>
        </p>
      </div>
    `;

    return;
  }

  messageContainer.innerHTML = '';
}

document.addEventListener('variant:change', function(event) {
  const variant = event.detail?.variant;
  const form = event.target;

  if (!variant || !form) return;

  const container = getProductAvailabilityContainer(form);
  const quantity = getQuantity(form);

  renderProductAvailability(container, variant.id, quantity);
});

document.addEventListener('change', function(event) {
  const quantityInput = event.target;

  if (!quantityInput.matches('input[name="quantity"]')) return;

  const form = quantityInput.form;

  if (!form) return;

  const container = getProductAvailabilityContainer(form);

  if (!container) return;

  const variantId = container.dataset.currentVariantId;

  if (!variantId) return;

  const quantity = parseInt(quantityInput.value || '1', 10);

  renderProductAvailability(
    container,
    variantId,
    Number.isNaN(quantity) ? 1 : quantity
  );
});

document.addEventListener('submit', function(event) {
  const form = event.target;

  if (!form.matches('form[action*="/cart/add"]')) return;

  const container = getProductAvailabilityContainer(form);

  if (!container) return;

  const availabilityInput = form.querySelector('[data-availability-property]');

if (!availabilityInput) return;

  const messageContainer = container.querySelector('[data-availability-message]');
  const leadTime = container.dataset.leadTime || '';

  if (!messageContainer) return;

  const messages = Array.from(
    messageContainer.querySelectorAll('.product-info__lead-time')
  )
    .map(element => element.textContent.replace(/\s+/g, ' ').trim())
    .filter(Boolean);
const inventoryDataElement = container.querySelector('[data-variant-inventory]');
const variantInput = form.querySelector('[name="id"]');
const variantId = variantInput?.value || container.dataset.currentVariantId;

let inventoryQty = 0;

if (inventoryDataElement && variantId) {
  try {
    const inventory = JSON.parse(inventoryDataElement.textContent);
    inventoryQty = Number(inventory[String(variantId)] || 0);
  } catch (error) {
    inventoryQty = 0;
  }
}
  let deliveryValue = '';

if (inventoryQty > 0 && getQuantity(form) <= inventoryQty) {
  deliveryValue = 'in stock';
} else if (inventoryQty > 0 && getQuantity(form) > inventoryQty) {
  const remainingQty = getQuantity(form) - inventoryQty;
  deliveryValue = `${inventoryQty} in stock / remaining ${remainingQty}: ${leadTime}`;
} else if (leadTime) {
  deliveryValue = leadTime;
}

availabilityInput.value = deliveryValue;

if (availabilityInput.parentNode) {
  form.appendChild(availabilityInput);
}

}, true);
async function syncCartDeliveryProperties() {
  const lineItems = document.querySelectorAll(
    'line-item[data-stock-available][data-lead-time]'
  );

  if (!lineItems.length) return;

  const cartResponse = await fetch('/cart.js');
  const cart = await cartResponse.json();

  let cartChanged = false;

  for (const lineItem of lineItems) {
    const quantityInput = lineItem.querySelector('[data-line-key]');

    if (!quantityInput) continue;

    const lineKey = quantityInput.dataset.lineKey;
    const item = cart.items.find(cartItem => cartItem.key === lineKey);

    if (!item) continue;

    const stockAvailable = Number(lineItem.dataset.stockAvailable || 0);
    const leadTime = lineItem.dataset.leadTime || '';
    const quantity = item.quantity;

    let deliveryValue = '';

    if (stockAvailable > 0 && quantity <= stockAvailable) {
      deliveryValue = 'in stock';
    } else if (stockAvailable > 0 && quantity > stockAvailable) {
      const remainingQuantity = quantity - stockAvailable;

      deliveryValue =
        `${stockAvailable} in stock / remaining ${remainingQuantity}: ${leadTime}`;
    } else if (leadTime) {
      deliveryValue = leadTime;
    }

    const currentDelivery = item.properties?.Delivery || '';

    if (currentDelivery === deliveryValue) continue;

    const properties = {
  ...(item.properties || {})
};

delete properties['_Availability message'];
delete properties['_Lead time'];
delete properties['_Stock available'];

properties.Delivery = deliveryValue;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        properties: properties
      })
    });

    cartChanged = true;
  }

  if (cartChanged) {
    window.location.reload();
  }
}

if (window.themeVariables?.settings?.pageType === 'cart') {
  syncCartDeliveryProperties();
}